/**
 * Service Initialization
 *
 * Handles initialization of cloud services that need to run before React renders.
 * This is the only file outside of /src/services that can import cloud SDKs.
 */

import { datadogRum } from '@datadog/browser-rum'
import { APM_CONFIG, isOnPrem } from '../config'
import { env } from '../utils/env'
import { API_URL } from '../utils/api'

/**
 * Initialize Datadog RUM for cloud deployments
 * Should be called before React renders
 */
export default function initializeDatadog(): void {
  if (isOnPrem) {
    return
  }

  datadogRum.init({
    applicationId: APM_CONFIG.datadog.applicationId,
    clientToken: APM_CONFIG.datadog.clientToken,
    site: APM_CONFIG.datadog.URL,
    service: APM_CONFIG.serviceName,
    env: env.APP_ENV,
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [API_URL], // connect distributed tracing to the API
  })
  datadogRum.startSessionReplayRecording()
}
